import { render, staticRenderFns } from "./R2023.vue?vue&type=template&id=5d376c94&scoped=true"
import script from "./R2023.vue?vue&type=script&lang=js"
export * from "./R2023.vue?vue&type=script&lang=js"
import style0 from "./R2023.vue?vue&type=style&index=0&id=5d376c94&prod&lang=less"
import style1 from "./R2023.vue?vue&type=style&index=1&id=5d376c94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.46.0__css-load_ecc709542230bcceb67dd6366ef941ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d376c94",
  null
  
)

export default component.exports